import { useGetResources } from '@hooks/useGetResources';

import Modal from '@helsenorge/designsystem-react/components/Modal';

import { trackTool } from '@helsenorge/framework-utils/adobe-analytics';

import { useAppDispatch, useAppSelector } from '../../store';
import { closeLightboxes } from '../../store/verktoy/slice/verktoySlice';
import { removeLaeringsaktivitetThunk } from '../../store/verktoy/thunks';
import { erVerktoyTilgjengeligMineVerktoy } from '../../utils/utils';

const DeleteVerktoyConfirmationMineVerktoy = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const resources = useGetResources();
  const aktivitetToRemove = useAppSelector(state => state.verktoy.aktivitetToRemoveMineVerktoy);

  if (!aktivitetToRemove?.LaeringsaktivitetId) {
    return null;
  }
  const onConfirm = (): void => {
    if (aktivitetToRemove.LaeringsaktivitetId) {
      trackTool('Verktøy', '', aktivitetToRemove.VerktoyNavn, 'fjern verktøy');
      dispatch(removeLaeringsaktivitetThunk({ aktivitetsId: aktivitetToRemove.LaeringsaktivitetId }));
    }
  };
  const handleClose = (): void => {
    dispatch(closeLightboxes());
  };

  let confirmButtonText = resources?.deleteVerktoyButtonText;
  let headerText = resources?.confirmFjernVerktoyHeader.replace('{0}', aktivitetToRemove.VerktoyNavn);
  let descriptionText: string | undefined;
  if (!erVerktoyTilgjengeligMineVerktoy(aktivitetToRemove)) {
    headerText = resources?.confirmSlettVerktoyHeader.replace('{0}', aktivitetToRemove.VerktoyNavn);
    descriptionText = resources?.confirmSlettUtgattVerktoyBody.replace('{0}', aktivitetToRemove.VerktoyNavn);
  } else if (aktivitetToRemove.KreverForskrivning) {
    descriptionText = resources?.confirmFjernVerktoyBodyForskrivning.replace('{0}', aktivitetToRemove.VerktoyNavn);
  } else {
    confirmButtonText = resources?.removeVerktoyButtonText;
    headerText = resources?.confirmFjernVerktoyHeader.replace('{0}', aktivitetToRemove.VerktoyNavn);
    descriptionText = resources?.confirmFjernVerktoyBody.replace('{0}', aktivitetToRemove.VerktoyNavn);
  }

  return (
    <Modal
      testId="delete-verktoy-confirmation"
      title={headerText || ''}
      description={descriptionText}
      primaryButtonText={confirmButtonText}
      secondaryButtonText={resources?.modalCancelButtonText}
      onSuccess={onConfirm}
      onClose={handleClose}
    ></Modal>
  );
};

export default DeleteVerktoyConfirmationMineVerktoy;
